module.exports = __webpack_public_path__ + "media/images/icons/flags/GB-b57b24bf1cc468c0ea68d2a96f4f144a.svg";